var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/Portal.tsx";
import ReactDOM from 'react-dom';
export const Portal = ({
  children
}) => /*#__PURE__*/ReactDOM.createPortal(children, document.body);